import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const GarageIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M14.5 1C14.7761 1 15 1.22386 15 1.5V14.5C15 14.7761 14.7761 15 14.5 15H14C13.7239 15 13.5 14.7761 13.5 14.5V5.5C13.5 5.22386 13.2761 5 13 5H3C2.72386 5 2.5 5.22386 2.5 5.5V14.5C2.5 14.7761 2.27614 15 2 15H1.5C1.22386 15 1 14.7761 1 14.5V1.5C1 1.22386 1.22386 1 1.5 1H14.5Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 10.5902V14.5C4 14.7761 4.22386 15 4.5 15H5C5.27614 15 5.5 14.7761 5.5 14.5V13.5H10.5V14.5C10.5 14.7761 10.7239 15 11 15H11.5C11.7761 15 12 14.7761 12 14.5V10.5902C12 10.2021 11.9096 9.81927 11.7361 9.47214L11.191 8.38197C10.7675 7.53501 9.90184 7 8.95492 7H7.04508C6.09816 7 5.2325 7.53501 4.80902 8.38197L4.26393 9.47214C4.09036 9.81927 4 10.2021 4 10.5902ZM5.3618 9.27639L5.8618 8.27639C5.9465 8.107 6.11963 8 6.30902 8H9.69098C9.88037 8 10.0535 8.107 10.1382 8.27639L10.6382 9.27639C10.8044 9.60884 10.5627 10 10.191 10H5.80902C5.43733 10 5.19558 9.60884 5.3618 9.27639ZM5.75 12.5C6.16421 12.5 6.5 12.1642 6.5 11.75C6.5 11.3358 6.16421 11 5.75 11C5.33579 11 5 11.3358 5 11.75C5 12.1642 5.33579 12.5 5.75 12.5ZM11 11.75C11 12.1642 10.6642 12.5 10.25 12.5C9.83579 12.5 9.5 12.1642 9.5 11.75C9.5 11.3358 9.83579 11 10.25 11C10.6642 11 11 11.3358 11 11.75Z"
		></path>
	</svg>
))
